import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const containerStyle = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${theme.spacing(1.5, 2)};
`;
